module.exports = __webpack_public_path__ + "img/matpl.0b9a35b9.jpg";